<app-modal>
    <ng-container title>
        <div class="validation-failures-title">
            <span class="title-text">{{ 'FEATURES.AGREEMENTS.VALIDATION_FAILURES.TITLE' | translate }}</span>
            <span class="subtitle">{{
                'FEATURES.AGREEMENTS.VALIDATION_FAILURES.RISK_ANALYSIS_COMMENT' | translate
            }}</span>
        </div>
    </ng-container>
    <ng-container body>
        <div *ngIf="validationFailures.length > 0">
            <app-table>
                <tr thead>
                    <app-table-header
                        [text]="'FEATURES.AGREEMENTS.VALIDATION_FAILURES.FIELD' | translate"
                        [width]="16"
                    />
                    <app-table-header
                        [text]="'FEATURES.AGREEMENTS.VALIDATION_FAILURES.TYPE' | translate"
                        [width]="12"
                    />
                    <app-table-header
                        [text]="'FEATURES.AGREEMENTS.VALIDATION_FAILURES.DESCRIPTION' | translate"
                        [dynamicWidth]="100"
                    />
                </tr>
                <ng-container tbody>
                    <tr *ngFor="let failure of validationFailures">
                        <td>{{ failure.field }}</td>
                        <td>{{ failure.type }}</td>
                        <td>{{ failure.description }}</td>
                    </tr>
                </ng-container>
            </app-table>
        </div>

        <app-risk-analysis [riskAnalysis]="riskAnalysis"></app-risk-analysis>
    </ng-container>
    <ng-container footer>
        <button (click)="closeModal()" type="button">
            {{ 'BUTTONS.CLOSE' | translate }}
        </button>
    </ng-container>
</app-modal>
